import type { BlockMedia, IImageComponentProps } from "@newxsystems/types";
import { getComponent } from "../../../../client";
import type { IBlockLogoProps } from "./BlockLogo.props";

type RegisteredImageProps = Omit<
  IImageComponentProps,
  "alt" | "caption" | "sizes" | "src" | "srcSet"
> & {
  alt: BlockMedia["alternateText"];
  caption?: string;
  height?: number;
  sizes?: string;
  src: BlockMedia["defaultSrc"];
  srcSet?: string;
  width?: number;
};

export const BlockLogo = ({
  media,
  className,
  imageClassName,
  loading,
  priority,
}: IBlockLogoProps) => {
  const Image = getComponent<RegisteredImageProps>("Image");

  if (!Image) {
    return null;
  }

  return (
    <Image
      alt={media.alternateText}
      className={className}
      height={media.height ?? undefined}
      imageClassName={imageClassName}
      loading={loading}
      priority={priority}
      sizes={media.sizes ?? undefined}
      src={media.defaultSrc}
      srcSet={media.srcSet ?? undefined}
      width={media.width ?? undefined}
      {...(media.caption != null ? { caption: media.caption } : {})}
    />
  );
};

BlockLogo.displayName = "Shared::BlockLogo";
